  <div class="container-fluid">
    <div class="row mt-4">
      <div class="col">
        <h5 class="blue"><i class="fas fa-plus"></i>&nbsp;Crear usuario</h5>
      </div>
    </div>
    <hr>
      <form #formNuevoUsuario="ngForm" (ngSubmit)="formSubmit(formNuevoUsuario)" novalidate="">
        <div class="container-fuid" style="height: 460px; overflow-y: auto; padding-right: 20px; overflow-x: hidden;">
          <div class="row">
            <div class="col col-12">
              <label class="form-label">Estación:</label>
              <br>
                <p-dropdown name="slcEstaciones" #slcEstaciones="ngModel" [options]="estaciones" [filter]="true" filterBy="label" [style]="{'width':'150px'}" [(ngModel)]="UsuarioRQ.idEstacion" optionLabel="label" optionValue="value" [required]="true"></p-dropdown>

              </div>
            </div>

            <div class="row mt-3">
              <div class="col col-12">
                <label class="form-label">Rol:</label>
                <div class="row">
                  @for (rol of roles; track rol) {
                    <div class="col-6 col-md-4 mb-2" style="font-size: 14px;">
                      <p-radioButton [inputId]="'rol' + rol.idRol" name="rol" [value]="rol.idRol" [(ngModel)]="UsuarioRQ.idRol" [required]="true"></p-radioButton>
                      <label [for]="'rol' + rol.idRol">&nbsp;{{ rol.rol }}</label>
                    </div>
                  }
                </div>
              </div>
            </div>
            @if (UsuarioRQ.idRol == 4) {
              <div class="row mt-4">
                <div class="col col-12">
                  <label class="form-label">Tipo de usuario:</label>
                  <div class="row">
                    @for (tipo of tiposUsuario; track tipo) {
                      <div class="col-6 col-md-4 mb-2" style="font-size: 14px;">
                        <p-radioButton [inputId]="'tipo' + tipo.idTipo" name="tipoUsuario" [value]="tipo.idTipo" [(ngModel)]="UsuarioRQ.idTipo" [required]="UsuarioRQ.idRol == 4"></p-radioButton>
                        <label [for]="'tipo' + tipo.idTipo" class="ml-2">&nbsp;{{ tipo.tipo }}</label>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
            <hr>
              <div class="row">
                <div class="col col-12">
                  <div class="form-group">
                    <label class="form-label">Número de empleado:</label>
                    <input type="text" autocomplete="off" class="form-control form-control-sm custom-input" placeholder="No. de Empleado" name="txtNoEmpleado" #txtNoEmpleado="ngModel" [(ngModel)]='UsuarioRQ.usuario' maxlength="15" pattern="^[0-9]{1,15}$" required>
                  </div>

                </div>
              </div>

              <div class="row mt-3">
                <div class="col col-12">
                  <label class="form-label">Nombre(s):</label>
                  <input type="text" autocomplete="off" class="form-control form-control-sm custom-input" placeholder="Nombre(s)" name="txtNombre" #txtNombre="ngModel" [(ngModel)]='UsuarioRQ.nombre' maxlength="25" pattern="^[a-zA-ZÀ-ÿñÑ\s]{2,25}$" required>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col col-6">
                  <label class="form-label">Apellido paterno:</label>
                  <input type="text" autocomplete="off" class="form-control form-control-sm custom-input" placeholder="Apellido paterno" name="txtAPaterno" #txtAPaterno="ngModel" [(ngModel)]='UsuarioRQ.apellidoPaterno' maxlength="25" pattern="^[a-zA-ZÀ-ÿñÑ\s]{2,25}$" required>
                </div>

                <div class="col col-6">
                  <label class="form-label">Apellido materno:</label>
                  <input type="text" autocomplete="off" class="form-control form-control-sm custom-input" placeholder="Apellido materno" name="txtAMaterno" #txtMaterno="ngModel" [(ngModel)]='UsuarioRQ.apellidoMaterno' maxlength="25" pattern="^[a-zA-ZÀ-ÿñÑ\s]{2,25}$" required>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col col-12">
                  <label class="form-label">Email:</label>
                  <div class="row">
                    <div class="col">
                      <input type="text" autocomplete="off" class="form-control form-control-sm custom-input" placeholder="Email" name="txtMail" #txtMail="ngModel" [(ngModel)]='UsuarioRQ.email' maxlength="45" required>
                    </div>
                    <div class="col">
                      <label><b>&#64;aeromexico.com</b></label>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col text-end">
                <button type="button" (click)="onClose()" class="btn btn-sm rounded-button btn-secondary">
                  <i class="fa fa-arrow-left"></i>
                  Regresar
                </button>
                <button type="submit" [disabled]="!formNuevoUsuario.form.valid" class="side-space btn btn-sm rounded-button btn-success">
                  Aceptar
                  <i class="fa fa-check"></i>
                </button>
              </div>
            </div>
          </form>

        </div>